import { Box, Skeleton, Typography, useTheme } from "@mui/material";
import { MonitoringCardProps, MonitoringCardTypeErrors } from "src/components/cards/custom/monitoring-card/MonitoringCard";
import { SenecEkpTheme } from "src/styles/ekp-theme/senecEkpTheme";

export const MonitoringCardBottomArea = ({
    topTitle,
    bottomTitle,
    bottomValue,
    isLoading,
    errors,
    errorMessages,
}: MonitoringCardProps) => {
    const theme: SenecEkpTheme = useTheme();
    return (
        <Box mt={1} display={"flex"} height={15} justifyContent={"space-between"} alignItems={"center"}>
            <Typography
                variant={"subtitle1"}
                sx={{
                    color: "text.primary",
                    textTransform: "none",
                    fontFamily: "Mark Pro, sans-serif",
                    fontWeight: 200,
                }}
                data-testid={`${topTitle}-card-bottomTitle`}
            >
                {bottomTitle}
            </Typography>
            {isLoading ? (
                <Skeleton
                    data-testid="skeleton-bottom-value"
                    variant="rounded"
                    sx={{ height: "100%", width: "50%", borderRadius: "12px" }}
                />
            ) : (
                <>
                    {errors && errorMessages && errors.includes(MonitoringCardTypeErrors.ERROR_BOTTOM_VALUE) ? (
                        <Typography
                            variant={"h5"}
                            sx={{
                                color: theme.palette.senecSecondary.neutralGray20,
                                textTransform: "none",
                                fontWeight: 700,
                                overflow: "hidden",
                            }}
                            data-testid={"Monitoring-Card-BottomValueError"}
                        >
                            {errorMessages.get(MonitoringCardTypeErrors.ERROR_BOTTOM_VALUE)}
                        </Typography>
                    ) : (
                        <Typography
                            variant={"h5"}
                            sx={{
                                color: "text.primary",
                                textTransform: "none",
                                fontWeight: 700,
                            }}
                            data-testid={`${topTitle}-card-bottomValue`}
                        >
                            {bottomValue}
                        </Typography>
                    )}
                </>
            )}
        </Box>
    );
};
